/* eslint-disable react/no-array-index-key */
import { useEffect, useState, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';

import { ReactComponent as MoneyCancelIcon } from '../../../assets/money-cancel-icon.svg';
import InfoSelectWithSidebar from '../../../common/info-select-with-sidebar/info-select-with-sidebar.component';

import { theme } from '../../../styles/themes';

import { IGenericInfoBlock } from '../../../models/generic-info-block/generic-info-block';
import GenericInfoBlock from '../../../common/generic-info-block/generic-info-block.component';

const ParcelNonCompensatedItemsWithSidebar = () => {
  const {
    parcelCreationStore: { isLoadingShipmentApi, getNonCompensatedItems },
    userStore: { user },
  } = useStore();

  const { t } = useTranslation();

  const [nonCompensatedItemsInfo, setNonCompensatedItemsInfo] =
    useState<IGenericInfoBlock>();

  const handleGetNonCompensatedItems = useCallback(async () => {
    const response = await getNonCompensatedItems();
    if (!response) return;
    setNonCompensatedItemsInfo(response);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetNonCompensatedItems();
  }, [handleGetNonCompensatedItems, user?.lang]);

  return (
    <InfoSelectWithSidebar
      bodyBackground={theme.colors.namedColors.white}
      sidebarName='non-compensated-items'
      placeholder={t('create_parcel_non_compensated_items')}
      sidebarTitle={t('create_parcel_non_compensated_items')}
      appearence='yellow'
      isLoading={isLoadingShipmentApi}
      icon={<MoneyCancelIcon />}>
      {nonCompensatedItemsInfo && (
        <GenericInfoBlock
          genericInfo={nonCompensatedItemsInfo}
          isLoading={isLoadingShipmentApi}
          mode='non-compensated'
        />
      )}
    </InfoSelectWithSidebar>
  );
};

export default observer(ParcelNonCompensatedItemsWithSidebar);
